import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom/dist";
import Table from "../../../../core/pagination/datatable";
import CommonFooter from "../../../../core/common/footer/commonFooter";
import {
  Edit,
  Eye,
  RotateCcw,
  Trash2,
  UserX,
} from "feather-icons-react/build/IconComponents";
// import CommonDeleteModal from "../../../../core/common/modal/commonDeleteModal";
import ViewRegistration from "./View";
import EditRegistration from "./Edit";
import Swal from "sweetalert2";
import AddRegistration from "./Add";
import ResignRegistration from "./Resign";
import Axios from "axios";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  ROLL_CALL_EMPLOYEES_LIST,
  ROLL_CALL_API_BASE_URL,
} from "../RollCallConfig/RollCallConfig";
import { useDispatch } from "react-redux";
import { setrollcall_registration_list } from "../../../../core/redux/action";
import { Spin } from "antd";
import ImageWithBasePath from "../../../../core/img/imagewithbasebath";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const RegistrationsList = () => {
  const dataSource = useSelector(
    (state) => state.rootReducer.rollcall_registration_list
  );

  console.log(dataSource);
  const dispatch = useDispatch();
  // const [searchQuery, setSearchQuery] = useState('');

  const [viewObj, setViewObj] = useState([]);
  const [editObj, setEditObj] = useState([]);
  const [resignObj, setResignObj] = useState([]);
  const [loading, setLoading] = useState(true);

  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const navigate = useNavigate();

  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  useEffect(() => {
    const raw = sessionStorage.getItem("rollcall-permissions");
    if (!raw) return;

    const permissions = JSON.parse(raw);

    // current route → "/rollcall/registrations"
    const currentRoute = window.location.pathname.replace("/", "");

    const pagePerm = permissions.find((p) => p.path === currentRoute);

    if (pagePerm) {
      setPerm({
        Read: pagePerm.Read,
        Write: pagePerm.Write,
        Delete: pagePerm.Delete,
        Export: pagePerm.Export,
      });
    }
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  useEffect(() => {
    setLoading(true);
    if (tokenData && superIdData) {
      Axios.get(
        `${ROLL_CALL_API_BASE_URL}${ROLL_CALL_EMPLOYEES_LIST}?superid=${superIdData}`,
        {
          headers: { Authorization: `Bearer ${tokenData}` },
        }
      )
        .then((response) => {
          console.log(response);
          if (response.data.status) {
            dispatch(setrollcall_registration_list(response.data.ResultData));
          } else {
            console.error("Error fetching data:", response.data.Message);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dispatch, superIdData, tokenData]);

  const handleDeleteConfirmation = (regid) => {
    if (tokenData) {
      Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(
              `${ROLL_CALL_API_BASE_URL}portal/emp/deleteEmployee`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tokenData}`,
                },
                body: JSON.stringify({ regid: regid }),
              }
            );

            const responseData = await response.json();
            console.log(responseData);

            if (responseData.status) {
              Swal.fire(
                "Deleted!",
                "Your item has been deleted.",
                "success"
              ).then(() => {
                window.location.reload();
              });
            } else {
              Swal.fire("Error", "Failed to delete the holiday.", "error");
            }
          } catch (error) {
            console.error("Error deleting holiday:", error);
            Swal.fire("Error", "Failed to delete the holiday.", "error");
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelled", "Your item is safe :)", "info");
        }
      });
    }
  };

  const filteredData = dataSource.filter(
    (item) =>
      (item && item.UserName && item.UserName.toLowerCase()) ||
      (item.branchname && item.branchname.toLowerCase()) ||
      (item.Departmentname && item.Departmentname.toLowerCase())
  );

  useEffect(() => {
    console.log("Updated DataSource:", filteredData);
  }, [filteredData]);

  const columns = [
    {
      title: "S.No",
      dataIndex: "sno",
      sorter: (a, b) => a.sno - b.sno,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Emp ID",
      dataIndex: "Badge",
      sorter: (a, b) => a.Badge.length - b.Badge.length,
    },
    {
      title: "Name",
      dataIndex: "UserName",
      sorter: (a, b) => a.UserName.length - b.UserName.length,
      render: (text, record) => {
        const handleClick = () => {
          navigate("/rollcall/additional-details", {
            state: { regid: record.regid },
          });
        };

        return (
          <span
            title={text}
            onClick={handleClick}
            style={{ cursor: "pointer" }}
          >
            {text.length > 11 ? `${text.substring(0, 11)}...` : text}
          </span>
        );
      },
    },
    {
      title: "Biometric",
      dataIndex: "CardId",
      sorter: (a, b) => a.CardId.length - b.CardId.length,
      render: (text) => text || "N/A",
    },
    {
      title: "Mobile",
      dataIndex: "Mobile",
      sorter: (a, b) => a.Mobile.length - b.Mobile.length,
      render: (text) => text || "N/A",
    },
    {
      title: "Designation",
      dataIndex: "Designation",
      sorter: (a, b) => a.Designation.length - b.Designation.length,
      render: (text) => (
        <span title={text}>
          {text.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    {
      title: "Department",
      dataIndex: "Departmentname",
      sorter: (a, b) => a.Departmentname.length - b.Departmentname.length,
      render: (text) => (
        <span title={text}>
          {text.length > 15 ? `${text.substring(0, 15)}...` : text}
        </span>
      ),
    },
    // {
    //   title: "Resign",
    //   dataIndex: "resign",
    //   render: (text) => (
    //     <span
    //       className={`badge table-badge ${text === "Yes" ? "bg-danger" : "bg-success"
    //         } fw-medium fs-10`}
    //     >
    //       {text}
    //     </span>
    //   ),
    //   sorter: (a, b) => a.code.length - b.code.length,
    // },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <>
          <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v" aria-hidden="true" />
          </Link>
          <ul className="dropdown-menu">
            <li>
              <Link
                to="#"
                className="dropdown-item"
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightViewReg"
                aria-controls="offcanvasRightViewReg"
                onClick={() => setViewObj(record)}
              >
                <Eye className="info-img" />
                View
              </Link>
            </li>
            {perm?.Write && (
              <li>
                <Link
                  to=""
                  className="dropdown-item"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightEditReg"
                  aria-controls="offcanvasRightEditReg"
                  onClick={() => setEditObj(record)}
                >
                  <Edit className="info-img text-info" />
                  Edit
                </Link>
              </li>
            )}
            {perm?.Delete && (
              <>
                <li>
                  <Link
                    to=""
                    className="dropdown-item"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightResignReg"
                    aria-controls="offcanvasRightResignReg"
                    onClick={() => setResignObj(record)}
                  >
                    <UserX className="info-img text-warning" />
                    Resign
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item mb-0"
                    onClick={() => handleDeleteConfirmation(record.regid)}
                  >
                    <Trash2 className="info-img text-danger" />
                    Delete
                  </Link>
                </li>
              </>
            )}
          </ul>
        </>
      ),
    },
  ];

  const handleReload = () => {
    window.location.reload();
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Emp ID": item.Badge || "N/A",
      Name: item.UserName || "N/A",
      Biometric: item.CardId || "N/A",
      Mobile: item.Mobile || "N/A",
      Designation: item.Designation || "N/A",
      Department: item.Departmentname || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Employee Data");
    XLSX.writeFile(wb, "Employee_Data.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.text("Employee Data Report", 14, 10);

    const tableColumn = [
      "S.No",
      "Emp ID",
      "Name",
      "Biometric",
      "Mobile",
      "Designation",
      "Department",
    ];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.Badge || "N/A",
      item.UserName || "N/A",
      item.CardId || "N/A",
      item.Mobile || "N/A",
      item.Designation || "N/A",
      item.Departmentname || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("Employee_Data.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Registrations
                    </h4>
                  </ol>
                </nav>
                <h6>Manage your registrations</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}

              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightAddReg"
                  aria-controls="offcanvasRightAddReg"
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set">
                <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="col-6 mb-2">
                    <label className="form-label"></label>
                  </div>
                </div>
              </div>
              {/* <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="dropdown me-2">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Status
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Active
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Inactive
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="dropdown">
                  <Link
                    to="#"
                    className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                    data-bs-toggle="dropdown"
                  >
                    Sort By : Last 7 Days
                  </Link>
                  <ul className="dropdown-menu  dropdown-menu-end p-3">
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Recently Added
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Ascending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Desending
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last Month
                      </Link>
                    </li>
                    <li>
                      <Link to="#" className="dropdown-item rounded-1">
                        Last 7 Days
                      </Link>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>

            <div className="card-body">
              {/* <div className="table-responsive brand-table">
                {loading ? (
                  <div className="loader m-auto"></div>
                ) : (
                  <Table columns={columns} dataSource={dataSource} />
                )}
              </div> */}

              <div className="table-responsive brand-table">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <Table columns={columns} dataSource={filteredData} />
                )}
              </div>
            </div>
          </div>
          {/* /product list */}
        </div>
        <CommonFooter />
      </div>
      <>
        <ViewRegistration viewObj={viewObj} />
        <EditRegistration editObj={editObj} />
        <ResignRegistration resignObj={resignObj} />
        <AddRegistration />
        {/* <CommonDeleteModal /> */}
      </>
    </div>
  );
};

export default RegistrationsList;
